import { useForeignContentNotification } from 'src/components/Feedback/ForeignContentNotification/ForeignContentNotification';
import { Spacer } from 'src/components-v2/Layout';
import { useCmsTheme } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';
import { NEXT_PUBLIC_IS_PREVIEW, NEXT_PUBLIC_PERCY_RUN } from 'src/env';
import { CmsThemes } from 'src/lib/constants';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';

const MainNavigationSpacer: React.FC<{ sx?: SxProps<ITheme> }> = ({ sx }) => {
  const cmsTheme = useCmsTheme();
  const { isForeignContentNotificationOpen } = useForeignContentNotification();
  // when the foreign-content banner is open the fixed nav translates down by
  // 100px (mobile) / 75px (tablet+) to make room for it (see
  // MainNavigationBar.module.scss `_foreign-content-notification-open`), so
  // reserve that extra height too — same gating as the nav's own shift
  const hasBannerOffset =
    isForeignContentNotificationOpen &&
    !NEXT_PUBLIC_PERCY_RUN &&
    !NEXT_PUBLIC_IS_PREVIEW;

  switch (cmsTheme) {
    case CmsThemes.WEB3:
      return (
        <Spacer
          className='nav-spacer'
          sx={{
            // doubled specificity: the global .nav-spacer class in
            // _layout.scss sets the closed heights and would otherwise win
            // the cascade over these
            '&&': {
              height: hasBannerOffset
                ? {
                    xs: '180px',
                    sm: '159px',
                    md: '170px',
                  }
                : {
                    xs: '80px',
                    sm: '84px',
                    md: '95px',
                  },
              // matches the nav's shift animation; scoped to height so
              // breakpoint crossings on resize don't animate
              transition: 'height 300ms ease-out',
              '@media (prefers-reduced-motion: reduce)': {
                transition: 'none',
              },
            },
            ...sx,
          }}
        />
      );
  }

  return null;
};

export default MainNavigationSpacer;
